import type { ReactElement } from "react";
import { Link } from "@tanstack/react-router";

import { Button } from "@/components/ui/button";

// Sticky top nav for the apex marketing site (getchill.ai).
// Keeps internal links as <Link> (SPA), and uses an anchor inside <Button asChild>
// so we get the shadcn Button styling on a real <a> tag (good for Cmd-click,
// SEO, and not breaking when JS hasn't hydrated yet).

export function MarketingNav(): ReactElement {
  return (
    <header className="marketing-nav sticky top-0 z-50 w-full">
      <div className="mx-auto flex h-[4.5rem] max-w-7xl items-center justify-between px-5 sm:px-8">
        <Link
          to="/"
          aria-label="Chill home"
          className="inline-flex items-center gap-2 text-lg font-semibold tracking-[-0.04em]"
        >
          <img
            src="/brand/chill-icon-upload.png"
            alt=""
            className="size-8 object-contain"
          />
          chill
        </Link>
        <nav className="flex items-center gap-1 sm:gap-7" aria-label="Primary">
          <a
            href="/#how-it-works"
            className="hidden text-sm text-[#52615e] transition-colors hover:text-[#11201d] sm:inline"
          >
            How it works
          </a>
          <Link
            to="/pricing"
            className="hidden text-sm text-[#52615e] transition-colors hover:text-[#11201d] sm:inline"
          >
            Pricing
          </Link>
          <Link
            to="/login"
            className="px-2 text-sm text-[#52615e] transition-colors hover:text-[#11201d]"
          >
            Log in
          </Link>
          <Button
            asChild
            className="h-10 rounded-full bg-[#dceffc] px-5 text-sm text-[#20272b] shadow-none hover:bg-[#c8e6fa]"
          >
            <Link to="/signup">Get started</Link>
          </Button>
        </nav>
      </div>
    </header>
  );
}
